import React, { useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import "./contact.css";

const Contact = () => {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name || !formData.email || !formData.message) {
      toast.error("Please fill all fields.");
      return;
    }
    toast("Message feature is coming soon.", {
      icon: '🚀',
      style: {
        borderRadius: '10px',
        background: '#333',
        color: '#fff',
      },
    });
    setFormData({ name: "", email: "", message: "" });
  };

  return (
    <section className="contact" id="contact">
      <Toaster position="top-center" reverseOrder={false}></Toaster>
      <div className="contact__container">
        <div className="contact__title">
          <h2>let's connect</h2>
        </div>
        <div className="contact__text">
          <p>Have a project, idea, or collaboration? Feel free to send me a message.</p>
        </div>
        
        <form className="contact__form" onSubmit={handleSubmit}>
          <div className="contact__form-group">
            <input 
              type="text" 
              name="name" 
              placeholder="Your Name" 
              value={formData.name} 
              onChange={handleChange} 
              autoComplete="off"
            />
          </div>
          <div className="contact__form-group">
            <input 
              type="email" 
              name="email" 
              placeholder="Your Email" 
              value={formData.email} 
              onChange={handleChange} 
              autoComplete="off"
            />
          </div>
          <div className="contact__form-group">
            <textarea 
              name="message" 
              placeholder="Your Message" 
              rows="5"
              value={formData.message} 
              onChange={handleChange}
            ></textarea>
          </div>
          <button className="contact__btn" type="submit">
            Send Message
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
